import { Add } from '@mui/icons-material'
import { Button, Stack } from '@mui/material'
import { FC, useState } from 'react'
import { RightSlider } from '../../../../../../../../components/sliders'
import { AddCompanyMemberForm } from './AddCompanyMemberForm'

export const AddCompanyMember: FC = () => {
  const [showSlideOut, setShowSlideOut] = useState(false)

  return (
    <>
      <RightSlider
        open={showSlideOut}
        setOpen={setShowSlideOut}
        outerBoxSx={{ maxWidth: '600px' }}
        closeButtonAction={() => setShowSlideOut(false)}
      >
        <AddCompanyMemberForm onClose={() => setShowSlideOut(false)} />
      </RightSlider>

      <Stack mb={2} alignItems="flex-end">
        <Button
          variant="contained"
          sx={{
            width: '180px',
            fontSize: '0.875rem',
            borderRadius: '8px',
            textTransform: 'none',
            padding: '.5rem 1rem',
          }}
          disableElevation={true}
          startIcon={<Add sx={{ color: 'white' }} />}
          onClick={() => setShowSlideOut(true)}
        >
          Add to company
        </Button>
      </Stack>
    </>
  )
}
